import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconV2FolderDocumentsOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="1em" height="1em"><path d="M29 27H5V9h22v16h2V7H19l-3-4H3v26h24.826zM5 7V5h9.984l1.549 2z" /><path d="M8 17v2h16v-2zM8 22h16v2H8zM8 12h9v2H8z" /></svg>
);
